<template>
  <div
    v-if="showModal"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center p-4 z-50"
  >
    <div class="confirm-dialog max-w-[512px] w-full shadow-lg rounded-md bg-white">
      <h3 class="ml-6 mt-7 mb-5">
        {{ $t('messages.enable_2fa_modal.title') }}
      </h3>
      <p class="b1 ml-6 mr-6 text-zyxel-gray-800">
        {{ $t('messages.enable_2fa_modal.description') }}
      </p>
      <div class="hidden sm:flex justify-between mt-[56px]">
        <div>
          <button
            class="button-cancel min-w-[80px] mb-6 px-4 py-2 rounded ml-6"
            @click="cancel"
          >
            {{ $t('messages.button.skip') }}
          </button>
        </div>
        <div>
          <button
            class="button-secondary mb-6 mr-4 px-4 py-2 rounded"
            @click="remind"
          >
            {{ $t('messages.button.remind') }}
          </button>
          <button
            class="button-primary mb-6 mr-6 px-4 py-2 rounded"
            @click="enable"
          >
            {{ $t('messages.button.enable') }}
          </button>
        </div>
      </div>
      <div class="flex-col sm:hidden justify-between mt-[42px] p-6">
        <button
          class="button-primary w-full rounded mb-4"
          @click="enable"
        >
          {{ $t('messages.button.enable') }}
        </button>
        <button
          class="button-secondary w-full rounded mb-4"
          @click="remind"
        >
          {{ $t('messages.button.remind') }}
        </button>
        <button
          class="button-cancel w-full rounded mb-6"
          @click="cancel"
        >
          {{ $t('messages.button.skip') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Enable2FAModal',
  props: {
    showModal: Boolean,
  },
  methods: {
    cancel() {
      this.$emit('skip');
    },
    remind() {
      this.$emit('remind')
    },
    enable() {
      this.$emit('enable')
    }
  }
}
</script>